import React from 'react';
import { Box, Typography } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import { MessageContainer } from '../../styles/StyledComponents';

const ChatMessage = ({ message, isUser }) => {
  return (
    <MessageContainer>
      <Box sx={{ 
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        gap: 1
      }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: 'text.secondary',
          fontSize: '0.85rem'
        }}>
          {isUser ? (
            <PersonOutlineIcon sx={{ fontSize: '1.1rem' }} />
          ) : (
            <SmartToyOutlinedIcon sx={{ fontSize: '1.1rem' }} />
          )}
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {isUser ? 'You' : 'Assistant'}
          </Typography>
        </Box>
        
        <Typography 
          variant="body1" 
          sx={{ 
            color: 'text.primary',
            fontSize: '0.9rem',
            lineHeight: 1.6,
            whiteSpace: 'pre-wrap'
          }}
        >
          {message.content}
        </Typography>
      </Box>
    </MessageContainer>
  );
};

export default ChatMessage;
